import { render, staticRenderFns } from "./PackagePop.vue?vue&type=template&id=ba01685c&scoped=true&"
import script from "./PackagePop.vue?vue&type=script&lang=js&"
export * from "./PackagePop.vue?vue&type=script&lang=js&"
import style0 from "./PackagePop.vue?vue&type=style&index=0&id=ba01685c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba01685c",
  null
  
)

export default component.exports